/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { TrademarkRequestList200ResponseMetaCountByStatusInner } from './TrademarkRequestList200ResponseMetaCountByStatusInner'
import {
  TrademarkRequestList200ResponseMetaCountByStatusInnerFromJSON,
  TrademarkRequestList200ResponseMetaCountByStatusInnerFromJSONTyped,
  TrademarkRequestList200ResponseMetaCountByStatusInnerToJSON,
} from './TrademarkRequestList200ResponseMetaCountByStatusInner'

/**
 *
 * @export
 * @interface TrademarkRequestList200ResponseMeta
 */
export interface TrademarkRequestList200ResponseMeta {
  /**
   * Количество заявок в каждом статусе под текущие фильтры (кроме статуса)
   * @type {Array<TrademarkRequestList200ResponseMetaCountByStatusInner>}
   * @memberof TrademarkRequestList200ResponseMeta
   */
  countByStatus: Array<TrademarkRequestList200ResponseMetaCountByStatusInner>
}

/**
 * Check if a given object implements the TrademarkRequestList200ResponseMeta interface.
 */
export function instanceOfTrademarkRequestList200ResponseMeta(
  value: object
): value is TrademarkRequestList200ResponseMeta {
  if (!('countByStatus' in value) || value['countByStatus'] === undefined)
    return false
  return true
}

export function TrademarkRequestList200ResponseMetaFromJSON(
  json: any
): TrademarkRequestList200ResponseMeta {
  return TrademarkRequestList200ResponseMetaFromJSONTyped(json, false)
}

export function TrademarkRequestList200ResponseMetaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TrademarkRequestList200ResponseMeta {
  if (json == null) {
    return json
  }
  return {
    countByStatus: (json['countByStatus'] as Array<any>).map(
      TrademarkRequestList200ResponseMetaCountByStatusInnerFromJSON
    ),
  }
}

export function TrademarkRequestList200ResponseMetaToJSON(
  value?: TrademarkRequestList200ResponseMeta | null
): any {
  if (value == null) {
    return value
  }
  return {
    countByStatus: (value['countByStatus'] as Array<any>).map(
      TrademarkRequestList200ResponseMetaCountByStatusInnerToJSON
    ),
  }
}
